module.exports = __webpack_public_path__ + "img/fe360027d2c44a415e66614cde855e86.jpg";